import React, { useState } from "react";
import TabEmpresa from "./TabEmpresa";
import TabLogo from "./TabLogo";
import { Tab, Tabs as Abas, TabList, TabPanel } from "react-tabs";
import styled from "styled-components";

function Tabs({
  touched,
  values,
  errors,
  handleChange,
  setFieldValue,
  onTestConnect,
  connected,
  isLoading
}) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Container>
      <StyledTabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <StyledTabList>
          <StyledTab>Empresa</StyledTab>
          <StyledTab>Logo</StyledTab>
        </StyledTabList>
        <StyledTabPanel>
          <TabEmpresa
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            onTestConnect={onTestConnect}
            connected={connected}
            isLoading={isLoading}
          />
        </StyledTabPanel>
        <StyledTabPanel>
          <TabLogo
            touched={touched}
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        </StyledTabPanel>
      </StyledTabs>
    </Container>
  );
}

const Container = styled.div`
  min-height: 400px;
  width: 100%;
  font-family: 'Mulish', sans-serif;
`;

const StyledTabs = styled(Abas)`
  width: 100%;
  font-family: 'Mulish', sans-serif;
`;

const StyledTabList = styled(TabList)`
  display: flex;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 24px;
  padding: 0;
  list-style: none;
  gap: 8px;
`;

const StyledTab = styled(Tab)`
  padding: 12px 24px;
  cursor: pointer;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  font-family: 'Mulish', sans-serif;
  outline: none;

  &:hover {
    color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 8px 8px 0 0;
  }

  &.react-tabs__tab--selected {
    color: #667eea;
    border-bottom-color: #667eea;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 8px 8px 0 0;
  }

  &:focus {
    box-shadow: none;
  }
`;

const StyledTabPanel = styled(TabPanel)`
  display: none;
  animation: fadeIn 0.3s ease;

  &.react-tabs__tab-panel--selected {
    display: block;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default Tabs;

